import { memo, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Chart } from "primereact/chart";
import { Panel } from "primereact/panel";
import { InputNumber } from "primereact/inputnumber";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { useReport } from "../context/report";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useReactToPrint } from "react-to-print";

export default memo(function ProducaoGeral({ dataProps }) {
  const [hidden, setHidden] = useState(false);
  const [value, setValue] = useState(87);
  const [realComputada, setRealComputada] = useState(false);

  const { handlePrint, data, printing, dataReal } = useReport();

  let dataProducao = dataProps ? dataProps : data;
  
  const tabelaRef = useRef();

  const handlePrintTable = useReactToPrint({
    content: () => tabelaRef.current,
    documentTitle: "Tabela de Eficiência de Producao",
  });

  const Tabela = () => {
    
    return (
      <>
        <Button
          icon="pi pi-print"
          className="p-m-2"
          onClick={handlePrintTable}
        />

        <div ref={tabelaRef} className="p-text-center">
          <h3>Eficiência - {dataProducao.periodo}</h3>
          <DataTable
            value={dataProducao.grupos}
            responsiveLayout="stack"
            emptyMessage="Nenhum dado encontrado"
            className="p-datatable-sm"
            style={{ width: '80%', margin: '0 auto'}}
          >
            <Column header="Turma" field="turma" sortable/>
            <Column header="Grupo" field="grupo" sortable/>
            <Column 
              header="Eficiência" 
              field="eficiencia" 
              sortable 
              body={(rowData) => {
                const val = rowData.eficiencia || 0;
                return (
                  <span style={{ 
                    fontWeight: 'bold', 
                    color: val >= value ? '#27ae60' : '#e74c3c' 
                  }}>
                    {Intl.NumberFormat('pt-BR', { 
                      minimumFractionDigits: 2, 
                      maximumFractionDigits: 2 
                    }).format(val)}%
                  </span>
                );
              }} 
            />
          </DataTable>
        </div>
      </>
    );
  };

  const Decrescente = () => {
    let labels = [];
    let datasets = [];
    let colors = [];

    dataProducao.grupos.forEach((element) => {
      if(hidden)
        labels.push(element.colaborador);
      else
        labels.push(element.turma + ' - G' + element.grupo.substring(element.grupo.length - 1, element.grupo.length))
      
      datasets.push(element.eficiencia);
      if (element.eficiencia > value) {
        colors.push("#27ae60");
      } else {
        colors.push("#e74c3c");
      }
    });

    const chartData = {
      labels: labels,
      datasets: [
        {
          label: "Eficiência",
          data: datasets,
          backgroundColor: colors,
        },
      ],
    };

    return (
      <Chart
        id="mediaGrupo"
        height={printing ? "210mm" : "650px"}
        width={printing ? "297mm" : "100%"}
        type="bar"
        data={chartData}
        plugins={[ChartDataLabels]}
        options={{
          maintainAspectRatio: false,
          scales: {
            y: {
              min: 0,
              max: 100
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            title: {
              display: true,
              text: "Classificação de Eficiência - " + dataProducao.periodo,
              font: {
                size: 20,
              },
            },
            datalabels: {
              clamp: true,
              formatter: (value) => {
                return printing
                  ? Intl.NumberFormat("pt-BR", {
                      maximumFractionDigits: 1,
                    }).format(value)
                  : Intl.NumberFormat("pt-BR", {
                      maximumFractionDigits: 2,
                    }).format(value);
              },
              font: {
                size: printing ? 13 : 18,
              },
              color: "#000",
            },
          },
        }}
      />
    );
  };

  const MediaTurmaGrupo = () => {
    let turmas = [];
    dataProducao.turmas.forEach((element) => {
      let index = turmas.indexOf(element.turma);
      if (index === -1) {
        turmas.push(element.turma);
      }
    });
    return (
      <div className="p-grid">
        {turmas.map((element, index) => {
          let grupos = dataProducao.grupos.filter((element2) => {
            return element2.turma === element;
          });

          let colors = [];
          let datasets = [];
          let labels = [];
          grupos.forEach((element) => {
            if(hidden)
              labels.push(element.colaborador);
            else
              labels.push(element.grupo);
            datasets.push(element.eficiencia);
            if (element.eficiencia > value) {
              colors.push("#27ae60");
            } else {
              colors.push("#e74c3c");
            }
          });

          const chartData = {
            labels: labels,
            datasets: [
              {
                label: "Eficiência",
                data: datasets,
                backgroundColor: colors,
              },
            ],
          };

          return (
            <div className="p-col-6 p-d-flex p-flex-column">
              <Button
                icon="pi pi-print"
                className="p-m-2"
                onClick={() => handlePrint(`chartTurmaGrupo${index}`)}
              />
              <Chart
                id={`chartTurmaGrupo` + index}
                height={printing ? "210mm" : "650px"}
                width={printing ? "297mm" : "100%"}
                type="bar"
                data={chartData}
                plugins={[ChartDataLabels]}
                options={{
                  maintainAspectRatio: false,
                  scales: {
                    x: {
                      ticks: {
                        font: {
                          size: 16,
                        },
                        color: "#000",
                      },
                    },
                    y: {
                      min: 0,
                      max: 100
                    },
                  },
                  plugins: {
                    legend: {
                      display: false,
                    },
                    title: {
                      display: true,
                      text: `${element} - ${dataProducao.periodo}`,
                      font: {
                        size: 20,
                      },
                    },
                    datalabels: {
                      clamp: true,
                      formatter: (value) => {
                        return printing
                          ? Intl.NumberFormat("pt-BR", {
                              maximumFractionDigits: 1,
                            }).format(value)
                          : Intl.NumberFormat("pt-BR", {
                              maximumFractionDigits: 2,
                            }).format(value);
                      },
                      font: {
                        size: printing ? 18 : 24,
                      },
                      color: "#000",
                    },
                  },
                }}
                style={{ padding: 20 }}
              />
            </div>
          );
        })}
      </div>
    );
  };

  const MediaGrupo = () => {
    let labels = [];

    dataProducao.grupos.forEach((element) => {
      let index = labels.indexOf(element.grupo);
      if (index === -1) {
        labels.push(element.grupo);
      }
    });

    labels = labels.sort();

    return (
      <div className="p-grid">
        {labels.map((element, index) => {
          let filtered = dataProducao.grupos.filter((element2) => {
            return element2.grupo === element;
          });

          filtered = filtered.sort(function (a, b) {
            if (a.turma < b.turma) {
              return -1;
            } else if (a.turma > b.turma) {
              return 1;
            }
            return 0;
          });

          let labels = [];
          let colors = [];
          let datasets = [];

          filtered.forEach((element) => {
            if(!hidden)
              labels.push([element.turma]);
            else
              labels.push([element.colaborador, element.turma]);

            datasets.push(element.eficiencia);
            if (element.eficiencia > value) {
              colors.push("#27ae60");
            } else {
              colors.push("#e74c3c");
            }
          });

          const chartData = {
            labels: labels,
            datasets: [
              {
                label: "Eficiência",
                data: datasets,
                backgroundColor: colors,
              },
            ],
          };

          return (
            <div className="p-col-6 p-d-flex p-flex-column">
              <Button
                icon="pi pi-print"
                className="p-m-2"
                onClick={() => handlePrint(`chartGrupo${index}`)}
              />
              <Chart
                id={`chartGrupo${index}`}
                height={printing ? "210mm" : "650px"}
                width={printing ? "297mm" : "100%"}
                type="bar"
                data={chartData}
                plugins={[ChartDataLabels]}
                options={{
                  maintainAspectRatio: false,
                  scales: {
                    y: {
                      min: 0,
                      max: 100
                    },
                  },
                  plugins: {
                    legend: {
                      display: false,
                    },
                    title: {
                      display: true,
                      text: `${element} - ${dataProducao.periodo}`,
                      font: {
                        size: 20,
                      },
                    },
                    datalabels: {
                      clamp: true,
                      formatter: (value) => {
                        return printing
                          ? Intl.NumberFormat("pt-BR", {
                              maximumFractionDigits: 1,
                            }).format(value)
                          : Intl.NumberFormat("pt-BR", {
                              maximumFractionDigits: 2,
                            }).format(value);
                      },
                      font: {
                        size: printing ? 13 : 24,
                      },
                      color: "#000",
                    },
                  },
                }}
                style={{ padding: 20 }}
              />
            </div>
          );
        })}
      </div>
    );
  };

  const MediaTurma = () => {
    const options = {
      maintainAspectRatio: false,
      plugins: {
        datalabels: {
          formatter: (value) => {
            if (realComputada) return null; 

            return Intl.NumberFormat("pt-BR", {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            }).format(value);
          },
          font: {
            size: 24,
          },
          color: "#000",
        },
        title: {
          display: true,
          text: "Eficiência por Turma - " + dataProducao.periodo,
          font: {
            size: 24,
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            font: {
              size: 16,
            },
            color: "#000",
          },
        },
        y: {
          stacked: true
        }
      },
    };

    let labels = [];
    let datasets = [[],[],[]];
    let colors = [];

    dataProducao.turmas.forEach((element) => {
      labels.push(element.turma);
      datasets[0].push(element.eficiencia);
      datasets[1].push(element.trama_cmpx);
      datasets[2].push(element.urdume_cmpx);
      if (element.eficiencia > value) {
        colors.push("#27ae60");
      } else {
        colors.push("#e74c3c");
      }
    });

    const chartData = {
      labels: labels,
      datasets: [
        {
          label: "Eficiência",
          data: datasets[0],
          backgroundColor: colors,
        },
        {
          label: "Trama CMPX",
          data: datasets[1],
          backgroundColor: '#feca57',
        },
        {
          label: "Urdume CMPX",
          data: datasets[2],
          backgroundColor: '#54a0ff',
        },
      ],
    };
    const linhaTurmaPlugin = {
      id: 'linhaTurmaPlugin',
      afterDatasetsDraw(chart) {
        if (!realComputada) return;

        const { ctx, scales: { y } } = chart;
        const meta = chart.getDatasetMeta(0);
        const dataValues = chart.data.datasets[0].data;

        ctx.save();
        
        ctx.font = 'bold 14px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        const desenharLinha = (x, larguraBarra, y, cor, texto, pontilhado, valor) => {
          ctx.beginPath();
          ctx.strokeStyle = cor;
          ctx.lineWidth = 4;
          if (pontilhado) ctx.setLineDash([6, 6]);
          ctx.moveTo(x - larguraBarra / 2, y);
          ctx.lineTo(x + larguraBarra / 2, y);
          ctx.stroke();
          if (pontilhado) ctx.setLineDash([]);
          const width = ctx.measureText(texto).width + 16;
          const valorX = x - width / 2;
          const valorY = y + valor;

          ctx.fillStyle = cor;
          ctx.beginPath();
          if (ctx.roundRect) ctx.roundRect(valorX, valorY, width, 26, 6);
          else ctx.fillRect(valorX, valorY, width, 26);
          ctx.fill();

          ctx.fillStyle = '#ffffff';
          ctx.fillText(texto, x, valorY + 26 / 2);
        };

        meta.data.forEach((bar, index) => {
          const valorComp = dataValues[index];

          const nomeTurma = dataProducao.turmas[index].turma;
          const dadoRealDaTurma = dataReal?.find(item => item.turma === nomeTurma);
          const valorReal = dadoRealDaTurma ? dadoRealDaTurma.eficiencia : 0;

          desenharLinha(bar.x, bar.width, y.getPixelForValue(valorReal), '#9c2113', `Real: ${Math.round(valorReal)}%`, true, 6);
          desenharLinha(bar.x, bar.width, y.getPixelForValue(valorComp), '#087528', `Comp: ${Math.round((valorComp))}%`, false, -32);
        });

        ctx.restore();
      }
    };

    return (
      <div>
        {!dataProps && (
          <Button 
            className={`p-mb-3 p-ml-2 ${realComputada ? 'p-button-secondary' : 'p-button-success'}`}
            icon="pi pi-check-circle"
            label="Real e Computada"
            onClick={() => setRealComputada(!realComputada)}
          />
        )}
        <Chart
          id="chartTurma"
          height={printing ? "210mm" : "650px"}
          width={printing ? "297mm" : "100%"}
          type="bar"
          data={chartData}
          plugins={[ChartDataLabels, linhaTurmaPlugin]}
          options={options}
        />
      </div>
    );
  };

  return (
    <div>
      <span>
        <strong>Eficiência Mínima</strong>
      </span>
      <div style={{ display: "block" }}>
        <InputNumber
          className="p-mb-3"
          onChange={(e) => setValue(e.value)}
          placeholder="Eficiência mínima"
          value={value}
        />

        <Button 
          className="p-mb-3 p-ml-2"
          icon="pi pi-print"
          onClick={() => setHidden(!hidden)}
        />
      </div>
      <Panel header="MÉDIA POR TURMA" toggleable>
        <Button
          icon="pi pi-print"
          className="p-m-2"
          onClick={() => handlePrint("chartTurma")}
        />
        <MediaTurma />
      </Panel>
      <Panel header="MÉDIA POR GRUPO" toggleable>
        <MediaGrupo />
      </Panel>
      <Panel header="CLASSIFICAÇÃO MÉDIA POR TURMA" toggleable>
        <MediaTurmaGrupo />
      </Panel>
      <Panel header="CLASSIFICAÇÃO MÉDIA GERAL" toggleable>
        <Button
          icon="pi pi-print"
          className="p-m-2"
          onClick={() => handlePrint("mediaGrupo")}
        />
        <Decrescente />
      </Panel>
      <Panel header="TABELA DE EFICIÊNCIA" toggleable>
        <Tabela />
      </Panel>
    </div>
  );
});
